import React from 'react';

export const Image = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="Ebene_1" data-name="Ebene 1" viewBox="0 0 80 80"><defs><style>.cls-1</style></defs><circle cx="59.09" cy="28.46" r="6" className="cls-1"/><path d="M67.39 14H12.61C8.96 14 6 16.92 6 20.5v39c0 3.58 2.97 6.5 6.61 6.5h54.78c3.65 0 6.61-2.92 6.61-6.5v-39c0-3.58-2.97-6.5-6.61-6.5ZM9.78 20.5c0-1.54 1.27-2.79 2.83-2.79h54.78c1.56 0 2.83 1.25 2.83 2.79v39c0 .5-.15.97-.39 1.38L55.38 44.26c-.72-.83-2.15-.83-2.87 0l-8.86 10.19-13.21-16.88c-.72-.91-2.28-.91-2.99 0L9.84 60.08c-.04-.19-.06-.38-.06-.58v-39Z" className="cls-1"/></svg>
    );
};
